import { Campaign } from '@/types/config'

export const campaignHasTestsRunning = (campaign: Campaign) => {
  return (
    campaign.is_active &&
    campaign.goal_ids.length > 0 &&
    campaign.testing.is_enabled
  )
}
